const globaldata = {
    success: true,
    data: {
        header: {
            name: "header",
            tag: "global",
            visible: true,
            logo: "https://cloud-cube.s3.amazonaws.com/qr3s5jz2j5uk/public/190355_1741861977727unipro-logo.jpg",
            menuItems: [
                {
                    label: "Home",
                    tags: "",
                    is_active: true,
                    seq: 1,
                    icon: {},
                    link: "/header",
                },
                {
                    label: "Services",
                    tags: "",
                    is_active: true,
                    seq: 2,
                    icon: {},
                    link: "/services",
                },
                {
                    label: "Our Clients",
                    tags: "",
                    is_active: true,
                    seq: 3,
                    icon: {},
                    link: "/clients",
                },
                {
                    label: "About Us",
                    tags: "",
                    is_active: true,
                    seq: 4,
                    icon: {},
                    link: "/about",
                },
                {
                    label: "Our Team",
                    tags: "",
                    is_active: false,
                    seq: 5,
                    icon: {},
                    link: "/team",
                },
                {
                    label: "Product",
                    tags: "",
                    is_active: true,
                    seq: 6,
                    icon: {},
                    link: "/",
                },
            ],
        },
        footer: {
            name: "footer",
            tag: "global",
            visible: true,
            data: {
                logo: "https://cloud-cube.s3.amazonaws.com/qr3s5jz2j5uk/public/190355_1741861977727unipro-logo.jpg",
                company_name: "UniPro World Pvt. Ltd.",
                privacy_link: {
                    text: "Privacy Policy",
                    link: "/privacy-policy",
                },
                company_email: "sales@uniproworld.com",
                company_address:
                    "3rd Floor, Tower-A, Gopal Palace, Nehrunagar, Ambawadi, Ahmedabad, Gujarat - 380015",
                text: "© UniPro World. All rights reserved.",
            },
        },
        links: {
            name: "links",
            tag: "global",
            socialLinks: [
                {
                    name: "linkedin",
                    link: "",
                    label: "",
                    icon_url: {
                        dark: "",
                        light: "",
                    },
                    meta: {
                        h: 10,
                        w: 10,
                    },
                    visible: true,
                    order: 1,
                },
                {
                    name: "facebook",
                    link: "",
                    label: "",
                    icon_url: {
                        dark: "",
                        light: "",
                    },
                    meta: {
                        h: 10,
                        w: 10,
                    },
                    visible: true,
                    order: 2,
                },
                {
                    name: "twitter",
                    link: "",
                    label: "",
                    icon_url: {
                        dark: "",
                        light: "",
                    },
                    meta: {
                        h: 10,
                        w: 10,
                    },
                    visible: true,
                    order: 3,
                },
                {
                    name: "instagram",
                    link: "",
                    label: "",
                    icon_url: {
                        dark: "",
                        light: "",
                    },
                    meta: {
                        h: 10,
                        w: 10,
                    },
                    visible: true,
                    order: 4,
                },
            ],
        },
        form: {
            name: "form",
            tag: "global",
            visible: true,
            data: {
                titleLeft: "LET'S",
                titleRight: "MEET",
                email: "sales@uniproworld.com",
                indiaOffice: {
                    title: "Contact Us",
                    addresses: [
                        "Noida, UP 201301"
                    ],
                },
                fields: [
                    {
                        name: "name",
                        label: "Full Name",
                        type: "text",
                        placeholder: "Enter your full name",
                    },
                    {
                        name: "phone",
                        label: "Phone Number",
                        type: "tel",
                        placeholder: "Enter your phone number",
                    },
                    {
                        name: "email",
                        label: "Email",
                        type: "email",
                        placeholder: "Enter your email",
                    },
                    {
                        name: "city",
                        label: "City",
                        type: "text",
                        placeholder: "Enter your city",
                    },
                    {
                        name: "businessName",
                        label: "Business Name",
                        type: "text",
                        placeholder: "Enter your business name",
                    },
                    {
                        name: "industryName",
                        label: "Industry Name",
                        type: "text",
                        placeholder: "Enter industry name",
                    },
                    {
                        name: "additionalInfo",
                        label: "Additional Information",
                        type: "textarea",
                        placeholder: "Enter additional information",
                    },
                ],
                submitText:"Send"
            }
        },
    },
};

export default globaldata;
